// extracted by css-extract-rspack-plugin
export default {"container":"LoginWithRecoveryCode_container__0ImSB"};